import React from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { LoginMenu } from "../api-authorization/LoginMenu";
import AdminNavbarNotificationsContainer from "./AdminNavbarNotifications";
import { AdminNavbarUser } from "./AdminNavbarUser";
import { WithAuth } from "../Authorization/WithAuth";

const HeaderLinks = () => {
  const user = useSelector(state => state.authentication.user);

  return (
    <div>
      <Nav pullRight>
        {
          user &&
          <WithAuth>
            <AdminNavbarNotificationsContainer />
          </WithAuth>
        }
        <LoginMenu />
        {
          user && <AdminNavbarUser user={user} />
        }
      </Nav>
    </div>
  );
}
export default HeaderLinks;
